<link
  href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css"
  rel="stylesheet"
/>
<div class="dashboard-header">
  <div>
    <img
      class="logo-img"
      src="../../assets/misha_healthai.webp"
      alt="Ambulance Image"
    />
  </div>
  <div class="breadcrumb">
    <div class="breadcrumb-path">
      <img
        (click)="moveToHome()"
        class="home-header-icon"
        src="../../../assets/home-button.webp"
        width="20"
        height="20"
      />
      <i class="fas fa-chevron-right"></i>
      <span>Doctor</span>
      <i class="fas fa-chevron-right"></i>
      <span>Dashboard</span>
    </div>
    <div class="breadcrumb-title">
      <h1>Dashboard</h1>
    </div>
  </div>
  <div class="search-notification">
    <div class="search-bar" *ngIf="!hideSearch">
      <i class="fas fa-search"></i>
      <input
        type="text"
        [value]="searchText"
        (input)="onQuickFilterChanged($event)"
        placeholder="Search"
      />
    </div>

    <div
      class="notification-wrapper"
      (mouseenter)="openNotifications(true)"
      (mouseleave)="openNotifications(false)"
    >
      <div class="bell bell-toggl">
        <i class="fa-solid fa-bell"></i>
        <span class="notification-count">{{ notifCount || 0 }}</span>
        <app-amb-notification
          [notifications]="notificationLists"
          [showNotification]="showNotifications"
        ></app-amb-notification>
      </div>
    </div>
  </div>
</div>
